import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()

const noticesRef = db.ref('noticeSettings')
const setcurrentNoticesRef = (currentUserId) => { return db.ref('noticeSettings/' + currentUserId) }
// const setNoticeRef = (currentUserId) => { return db.ref('users/' + currentUserId + '/userInfo') }
export const noticeSettingsModule = {
  namespaced: true,
  state: {
    noticeSettings: {},
    currentNoticeSettings: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.GET_NOTICESETTINGS]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_NOTICES')
      bindFirebaseRef('noticeSettings', noticesRef, { wait: true })
    }),
    [getterConstants.GET_CURRENT_NOTICESETTINGS]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentNoticeSettings', db.ref('noticeSettings/' + currentUserId), { wait: true })
    }),
    [getterConstants.SET_CURRENT_NOTICESETTNGES]: firebaseAction((context, value) => {
      setcurrentNoticesRef(context.rootState.currentUserId).set(value)
    })
  },
  getters: {
    getNoticeSettings: state => state.noticeSettings,
    getCurrentNoticeSettings: state => state.currentNoticeSettings
    /*
    getLatestNoticesByUserId: (state, getters, rootState) => {
      let latestNotices = []
      // if (rootState.currentUser && state.currentNotices) {
      //   const currentUser = rootState.currentUser
      //   const currentNotices = state.currentNotices
      const currentUser = rootState.currentUser || {}
      const currentNotices = state.currentNotices
      if (currentUser['.key'] && currentNotices) {
        delete currentNotices['.key']
        delete currentNotices['.value']
        console.log('getLatestNoticesByUserId:', currentUser['.key'], currentUser, currentNotices)
        for (const key of Object.keys(currentNotices).sort().reverse()) {
          console.log('getLatestNoticesByUserId:', currentNotices[key], currentNotices[key].createdAt / 1000, currentUser.lastNotice)
          if (currentNotices[key] && currentNotices[key].createdAt / 1000 > (currentUser.lastNotice || 0)) {
            latestNotices.push({ key: key, notice: currentNotices[key] })
          } else {
            break
          }
        }
      }
      console.log('getLatestNoticesByUserId:latestNotices', latestNotices)
      return latestNotices
    }
    */
    /*
    getLatestNoticesByUserId: (state, getters, rootState) => {
      let latestNotices = []
      if (rootState.currentUser && state.currentNotices) {
        const currentUser = rootState.currentUser
        const currentNotices = state.currentNotices
        for (let key in currentNotices) {
          if (currentNotices[key] && currentNotices[key].createdAt / 1000 > currentUser.lastNotice) {
            latestNotices.push({ key: key, notice: currentNotices[key] })
          }
        }
        latestNotices.sort(function (a, b) {
          // console.log(a.notice.createdAt)
          if (a.notice.createdAt > b.notice.createdAt) return -1
          if (a.notice.createdAt < b.notice.createdAt) return 1
          return 0
        })
      }
      return latestNotices
    }
    */
  }
}



// WEBPACK FOOTER //
// ./src/stores/noticeSettings.js